var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sweet-modal',{ref:"modal",attrs:{"icon":_vm.modalIcon,"overlay-theme":"dark","modal-theme":_vm.isContrast ? 'dark' : 'light'}},[_c('span',{staticClass:"display-4"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }